import * as React from "react"
import { Flex, Container, Text } from "@chakra-ui/react"
import { useRecoilState, useSetRecoilState } from "recoil"
import layoutStates, { changeTabSelector } from "../../../recoil/atoms/layout"
import {
  SwitcherIcon,
  StyledChatIcon
} from "../small-view/full-screen-mobile-interface/full-screen-mobile-interface.styled"
import { useRecoilValue } from "recoil"
import { brandingSelector, roomSelector } from "../../../recoil/atoms/room"
import { chatCountAtom, chatIsReadSelector } from "../../../recoil/atoms/chats"
import { IoChatbubbleSharp } from "react-icons/io5"
import {
  TabSwitcherProps,
  SwitcherIconsProps
} from "../small-view/full-screen-mobile-interface/full-screen-mobile-interface.interface"
import { IconButton } from "../../common/buttons"
import { viewDependingLayoutAtom } from "../../../recoil/atoms/view"
import { badgeHistoryListSelector } from "../../../recoil/atoms/badgeHistory"
import useLocalUserHasPermissions from "../../../hooks/useLocalUserHasPermissions"
import {
  mobileVideosTabSelector,
} from "../../../recoil/selectors/layoutSelectors/mobile-layot-selectors"
import { GrowingMenu } from "../../common/growing-menu"
import { shoppableVideosSelector } from "../../../recoil/selectors/shoppable-videos-selector"
import { shoppableVideosListSelector } from "../../../recoil/atoms/shoppableVideos"
import { CirclePlayIcon } from "../../common/icons"
import { pollsAtom } from "../../../recoil/atoms/polls"
import { shoppableMNPVideoAtom } from "../../../recoil/atoms/shoppableVideos"
import { someHaveOnDeviceSelector } from "../../../recoil/selectors/some-have-on-selectors"
import { GiShoppingBag } from "react-icons/gi"
import { useLocalUserType } from "../../../hooks/useLocalUserType"

const FeaturedIcon: React.FC<SwitcherIconsProps> = ({
  isLandscape,
  isBadgesHistoryTab,
  isVisibleMobileFSTabs,
  callback,
  allBadgeHistoryLength,
  roomStyles,
  iconButtonPros
}) => {
  const [{ enabledShoppableMNP }] = useRecoilState(shoppableMNPVideoAtom)

  return (
    <IconButton
      width="1.9rem"
      height={isLandscape ? "1.6rem" : "1.9rem"}
      transform="translate(0%, 15%)"
      onClick={callback}
      className="icon-ios"
      isMobile={true}
      opacity={
        allBadgeHistoryLength === 0 && !enabledShoppableMNP
          ? 0.5
          : !isVisibleMobileFSTabs
          ? 1
          : 1
      }
      {...iconButtonPros}
    >
      <SwitcherIcon
        as={GiShoppingBag}
        className="icon-ios"
        isActive={isBadgesHistoryTab}
        roomStyles={roomStyles}
        strokewith="36px" /* style={{fontSize: 'calc(1.6rem + 2px)'}} */
      />
    </IconButton>
  )
}

const VideosIcon: React.FC<SwitcherIconsProps> = ({
  isLandscape,
  callback,
  roomStyles,
  iconButtonPros,
  isVideos,
  isVideosTab
}) => {
  const [targetTabIndex] = useRecoilState<number>(
    layoutStates.historyTabEnabledMobile
  )
  const { isModerator } = useLocalUserType()

  const shoppableVideosList = useRecoilValue(shoppableVideosListSelector)
  const [isVisibleMobileFSTabs] = useRecoilState<boolean>(
    layoutStates.visibleMobileFSTabs
  )
  const [{ enabledShoppableMNP }] = useRecoilState(shoppableMNPVideoAtom)
  const someHaveOnDevice = useRecoilValue(someHaveOnDeviceSelector)

  return (
    <IconButton
      width="1.9rem"
      height={isLandscape ? "1.6rem" : "2rem"}
      transform={isLandscape ? "translate(0%, 15%)" : "translate(0%, 0%)"}
      className="icon-ios"
      onClick={callback}
      isMobile={true}
      opacity={
        (shoppableVideosList.length === 0 && !isModerator) || someHaveOnDevice
          ? 0.5
          : !isVisibleMobileFSTabs
          ? 1
          : !isVideosTab
          ? 1
          : 1
      }
      {...iconButtonPros}
    >
      <CirclePlayIcon
        isActive={targetTabIndex === 1 && isVisibleMobileFSTabs}
        customStyles={{
          color: enabledShoppableMNP
            ? roomStyles?.secondaryAccessButtonSelectedTextColor
            : targetTabIndex === 1 && isVisibleMobileFSTabs
            ? roomStyles?.accessButtonSelectedTextColor ?? "#000"
            : "#FFFFFF",
          border: enabledShoppableMNP
            ? `2px solid ${roomStyles?.secondaryAccessButtonSelectedTextColor}`
            : "2px solid #FFFFFF"
        }}
      />
      {/* <SwitcherIcon as={PlayIcon} strokewith="2rem" roomStyles={roomStyles} /> */}
    </IconButton>
  )
}

const ChatIcon: React.FC<SwitcherIconsProps> = ({
  isLandscape,
  isVisibleMobileFSTabs,
  roomStyles,
  isChat,
  iconButtonPros,
  callback
}) => {
  const chatCount = useRecoilValue(chatCountAtom)

  const polls = useRecoilValue(pollsAtom)
  const room = useRecoilValue(roomSelector)
  const { isModerator } = useLocalUserType()
  const mobilePoll = polls
    .filter(el => el.isVisible && el.isVisibleMobile)
    .sort((a, b) => (a?.timestamp < b?.timestamp ? -1 : 1))
  const isEnabledChat = React.useMemo(
    () =>
      ((chatCount !== 0 || mobilePoll.length !== 0 || isModerator) &&
        !room?.chatInputBoxOverlay) ||
      room?.chatInputBoxOverlay,
    [chatCount, isModerator, mobilePoll.length, room?.chatInputBoxOverlay]
  )
  return (
    <IconButton
      width="1.9rem"
      height={isLandscape ? "1.6rem" : "1.9rem"}
      onClick={callback}
      marginLeft="0.4rem"
      isMobile={true}
      transform="translate(0%, 15%)"
      opacity={!isEnabledChat ? 0.5 : !isVisibleMobileFSTabs ? 1 : 1}
      {...iconButtonPros}
    >
      <Container p="0" centerContent pos="relative">
        <Flex pos="relative">
          <StyledChatIcon
            as={IoChatbubbleSharp}
            roomStyles={roomStyles}
            className="icon-ios"
            isActive={isChat}
          />
          <Text
            fontSize="0.5rem"
            p="0"
            m="0"
            pos="absolute"
            color={
              isChat
                ? roomStyles?.accessButtonSelectedTextColor ?? "#000"
                : roomStyles?.overlayEmojiStrokeColor ?? "white"
            }
            left={chatCount > 99 ? "7px" : chatCount > 9 ? "8px" : "10px"}
            bottom={chatCount > 99 ? "7.5px" : "8px"}
          >
            {chatCount > 99 ? 99 : chatCount}
          </Text>
          {chatCount > 99 && (
            <Text
              color={
                isChat
                  ? roomStyles?.accessButtonSelectedTextColor ?? "#000"
                  : roomStyles?.overlayEmojiStrokeColor ?? "white"
              }
              pos="absolute"
              fontSize={"0.4rem"}
              p="0"
              m="0"
              right="3.5px"
              top="4.7px"
            >
              +
            </Text>
          )}
        </Flex>
      </Container>
    </IconButton>
  )
}

const TabSwitcher: React.FC<TabSwitcherProps> = ({
  isFSScreenButtonsControls,
  isHeartIcon
}) => {
  const { isModerator } = useLocalUserType()
  const isVideos = useRecoilValue(mobileVideosTabSelector)
  const isShoppableVideos = useRecoilValue(shoppableVideosSelector)
  const roomStyles = useRecoilValue(brandingSelector)
  const room = useRecoilValue(roomSelector)
  const [{ enabledShoppableMNP }] = useRecoilState(shoppableMNPVideoAtom)
  const chatCount = useRecoilValue(chatCountAtom)
  const allBadgeHistory = useRecoilValue(badgeHistoryListSelector)
  const { canUseChat, canSeeHistory } = useLocalUserHasPermissions()
  const tab = useRecoilValue(layoutStates.activeTab)
  const someHaveOnDevice = useRecoilValue(someHaveOnDeviceSelector)
  const polls = useRecoilValue(pollsAtom)
  const mobilePoll = polls
    .filter(el => el.isVisible && el.isVisibleMobile)
    .sort((a, b) => (a?.timestamp < b?.timestamp ? -1 : 1))
  const shoppableVideosList = useRecoilValue(shoppableVideosListSelector)
  const [isVisibleMobileFSTabs, setVisibleMobileFSTabs] =
    useRecoilState<boolean>(layoutStates.visibleMobileFSTabs)
  const { isLandscape } = useRecoilValue(viewDependingLayoutAtom)
  const isVideosTab = React.useMemo(() => {
    return isShoppableVideos
  }, [isShoppableVideos])
  const isEnabledChat =
    ((chatCount !== 0 || mobilePoll.length !== 0) &&
      !room?.chatInputBoxOverlay) ||
    room?.chatInputBoxOverlay ||
    isModerator
  const setIsChatTab = useSetRecoilState<boolean>(layoutStates.isChatTab)
  const setChatIsRead = useSetRecoilState<boolean>(chatIsReadSelector)
  const setTab = useSetRecoilState(changeTabSelector)
  const handleGoToChat = React.useCallback(() => {
    if (isEnabledChat) {
      setVisibleMobileFSTabs(true)
      setTab("chat")
      setIsChatTab(true)
      setChatIsRead(true)
    }
  }, [
    isEnabledChat,
    setChatIsRead,
    setIsChatTab,
    setVisibleMobileFSTabs,
    setTab
  ])
  const handleGoToBadges = React.useCallback(() => {
    if (allBadgeHistory.length !== 0 || enabledShoppableMNP || isModerator) {
      setTab("shop")
      setVisibleMobileFSTabs(true)
    }
  }, [
    allBadgeHistory.length,
    enabledShoppableMNP,
    isModerator,
    setVisibleMobileFSTabs,
    setTab
  ])

  const handleGoToVideos = React.useCallback(() => {
    if (isVideosTab && !someHaveOnDevice && shoppableVideosList.length !== 0) {
      setTab("watch")
      setVisibleMobileFSTabs(true)
    }
  }, [
    isVideosTab,
    setVisibleMobileFSTabs,
    shoppableVideosList.length,
    someHaveOnDevice,
    setTab
  ])

  const icons = React.useMemo<{ icon: React.ReactNode; enabled: boolean }[]>(
    () => [
      {
        icon: (
          <ChatIcon
            isLandscape={isLandscape}
            callback={handleGoToChat}
            roomStyles={roomStyles}
            isVisibleMobileFSTabs={isVisibleMobileFSTabs}
            isChat={tab == "chat"}
            iconButtonPros={{ transform: "unset" }}
          />
        ),
        enabled: canUseChat || isModerator
      },

      {
        icon: (
          <VideosIcon
            isLandscape={isLandscape}
            callback={handleGoToVideos}
            roomStyles={roomStyles}
            isVideosTab={tab === "watch"}
            iconButtonPros={{ transform: "unset" }}
          />
        ),
        enabled:
          (isShoppableVideos && shoppableVideosList.length !== 0) || isModerator
      },

      {
        icon: (
          <FeaturedIcon
            allBadgeHistoryLength={allBadgeHistory.length}
            roomStyles={roomStyles}
            callback={handleGoToBadges}
            isBadgesHistoryTab={tab === "shop"} // #here
            isVisibleMobileFSTabs={isVisibleMobileFSTabs}
            isLandscape={isLandscape}
            iconButtonPros={{ transform: "unset" }}
          />
        ),
        enabled:
          (canSeeHistory && allBadgeHistory.length !== 0) ||
          enabledShoppableMNP ||
          isModerator
      }
    ],
    [
      allBadgeHistory.length,
      canSeeHistory,
      canUseChat,
      enabledShoppableMNP,
      handleGoToBadges,
      handleGoToChat,
      handleGoToVideos,
      tab,
      isLandscape,
      isModerator,
      isShoppableVideos,
      isVisibleMobileFSTabs,
      roomStyles,
      shoppableVideosList.length
    ]
  )

  const items = React.useMemo(
    () =>
      icons.reduce((acc, item) => {
        if (item.enabled) {
          acc.push(item.icon)
        }
        return acc
      }, [] as React.ReactNode[]),
    [icons]
  )

  const isGrowingMenu = React.useMemo<boolean>(() => {
    return isLandscape && items.length !== 0
  }, [isLandscape, items.length])

  return (
    <>
      {isGrowingMenu && (
        <Flex marginBottom="5px">
          <GrowingMenu
            items={items}
            numberOfVisibleElements={items.length}
            customStyles={{
              toggleIconStyles: {
                stroke: roomStyles?.overlayEmojiStrokeColor ?? "white"
              },
              container: {
                transform: isLandscape && "translate(0%, 15%)"
              }
            }}
          />
        </Flex>
      )}
      <Flex flexDir="column">
        {(canUseChat || isModerator) && !isGrowingMenu && (
          <IconButton
            width="1.9rem"
            height={isLandscape ? "1.8rem" : "2.3rem"}
            onClick={handleGoToChat}
            isMobile={true}
            className="icon-ios"
            transform="translate(0%, 0%)"
            opacity={!isShoppableVideos ? 0.5 : !isVisibleMobileFSTabs ? 1 : 1}
          >
            <Container p="0" centerContent pos="relative" className="icon-ios">
              <Flex pos="relative" className="icon-ios">
                <StyledChatIcon
                  as={IoChatbubbleSharp}
                  roomStyles={roomStyles}
                  className="icon-ios"
                  isActive={tab === "chat"}
                />
                <Text
                  fontSize="0.5rem"
                  p="0"
                  m="0"
                  pos="absolute"
                  color={
                    tab === "chat"
                      ? roomStyles?.accessButtonSelectedTextColor ?? "#000"
                      : roomStyles?.overlayEmojiStrokeColor ?? "white"
                  }
                  left={chatCount > 99 ? "7px" : chatCount > 9 ? "8px" : "10px"}
                  bottom={chatCount > 99 ? "7.5px" : "8px"}
                >
                  {chatCount > 99 ? 99 : chatCount}
                </Text>
                {chatCount > 99 && (
                  <Text
                    color={
                      tab === "chat"
                        ? roomStyles?.accessButtonSelectedTextColor ?? "#000"
                        : roomStyles?.overlayEmojiStrokeColor ?? "white"
                    }
                    pos="absolute"
                    fontSize={"0.4rem"}
                    p="0"
                    m="0"
                    right="3.5px"
                    top="4.7px"
                  >
                    +
                  </Text>
                )}
              </Flex>
            </Container>
          </IconButton>
        )}
        {!isGrowingMenu &&
          ((isVideosTab && shoppableVideosList.length !== 0) ||
            isModerator) && (
            <VideosIcon
              isVideos={isVideos}
              isLandscape={isLandscape}
              callback={handleGoToVideos}
              roomStyles={roomStyles}
            />
          )}

        {((canSeeHistory && allBadgeHistory.length !== 0) ||
          enabledShoppableMNP ||
          isModerator) &&
          !isGrowingMenu && (
            <IconButton
              width="1.9rem"
              height={isLandscape ? "1.6rem" : "2.2rem"}
              transform="translate(0%, 3px)"
              onClick={handleGoToBadges}
              isMobile={true}
              className="icon-ios"
              opacity={
                allBadgeHistory.length === 0 &&
                !enabledShoppableMNP &&
                !isModerator
                  ? 0.5
                  : !isVisibleMobileFSTabs
                  ? 1
                  : 1
              }
            >
              <SwitcherIcon
                className="icon-ios"
                as={GiShoppingBag}
                roomStyles={roomStyles}
                strokewith="36px"
                isActive={tab === "shop"}
              />
            </IconButton>
          )}
      </Flex>
    </>
  )
}

export default TabSwitcher
